import dayjs, {Dayjs} from "dayjs"
import "dayjs/locale/en-gb"
import "dayjs/locale/en"
import utc from "dayjs/plugin/utc"
import tz from "dayjs/plugin/timezone"
import duration, {Duration} from 'dayjs/plugin/duration'
import customParseFormat from "dayjs/plugin/customParseFormat";
import LocalizedFormat from "dayjs/plugin/localizedFormat"
import RelativeTime from "dayjs/plugin/relativeTime"
import advancedFormat from "dayjs/plugin/advancedFormat";

export const configureDayJs = () => {
    dayjs.extend(utc)
    dayjs.extend(tz)
    dayjs.extend(duration)
    dayjs.extend(customParseFormat)
    dayjs.extend(LocalizedFormat)
    dayjs.extend(RelativeTime)
    dayjs.extend(advancedFormat)

    const userLocale = Intl.DateTimeFormat().resolvedOptions().locale
    dayjs.locale(userLocale) // use locale
}

export const timeOfDayStringToDayjs = (timezone: string, timeOfDayString: string): Dayjs => {
    return dayjs.tz(timeOfDayString, "HH:mm", timezone)
}

export const dayjsToDisplayString = (datetime: Dayjs): string => {
    return datetime.format("L LT")
}
export const dayjsToMonthDayYear = (datetime: Dayjs): string => {
    return datetime.format("MMM DD, YYYY")
}
export const dayjsToMonthDay = (datetime: Dayjs): string => {
    return datetime.format("MMM DD")
}
export const durationToString = (duration?: number | Duration): string | undefined => {
    if (duration === undefined) {
        return "00:00:00"
    } else if (typeof (duration) === 'number') {
        return dayjs.duration(duration.valueOf() * 1000).format("HH:mm:ss")
    } else {

        console.log(duration.toJSON(), duration.format("HH:mm:ss"))
        return duration.format("HH:mm:ss")
    }
}

export const durationSecondsToParts = (duration?: number): { hours: string, minutes: string, seconds: string } => {
    if (duration === undefined)
        return {hours: "00", minutes: "00", seconds: "00"}

    const totalSeconds = Math.floor(duration)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return {
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
    }
}

export const durationPartsToSeconds = (hoursValue: string, minutesValue: string, secondsValue: string): number => {
    const normalizedHours = hoursValue.trim() === "" ? "0" : hoursValue.trim()
    const normalizedMinutes = minutesValue.trim() === "" ? "0" : minutesValue.trim()
    const normalizedSeconds = secondsValue.trim() === "" ? "0" : secondsValue.trim()

    if (!/^\d+$/.test(normalizedHours) || !/^\d+$/.test(normalizedMinutes) || !/^\d+$/.test(normalizedSeconds))
        throw new Error("Duration values must be numeric")

    const hours = Number(normalizedHours)
    const minutes = Number(normalizedMinutes)
    const seconds = Number(normalizedSeconds)

    if (minutes > 59)
        throw new Error("Minutes must be between 00 and 59")

    if (seconds > 59)
        throw new Error("Seconds must be between 00 and 59")

    return hours * 3600 + minutes * 60 + seconds
}
